module.exports = __webpack_public_path__ + "img/HARMONY_ONE.94338320.png";